/* eslint-disable no-param-reassign */
import { FC } from 'react';
import withoutHydration from 'react-without-hydration';
import parse from 'html-react-parser';
import cn from 'classnames';

import classes from 'src/styles/_commonClasses.module.scss';
import styles from 'src/components/Sections/InlineHtml/InlineHtml.module.scss';
import { SectionComponentTextInterface } from 'types/componentTypes';
import { capitalizeFirstLetter, replaceContentfulVariables } from 'lib/text.service';
import { useHtmlParserReplace } from 'lib/tag.service';
import { CustomJson } from 'src/__generated__/graphqlTypes';
import { getOracleFormattedDate } from 'lib/date.service';

const formatData = (data: Record<string, any>) => {
  const { formatType, ...rest } = data;
  const result: Record<string, any> = {};
  Object.entries(rest).forEach(([key, value]) => {
    if (typeof value === 'string') {
      let validDate = value;

      if (value.length === 10) {
        validDate = `${value}T00:00:00`;
      }

      if (Number.isNaN(new Date(validDate).getTime())) {
        result[key] = getOracleFormattedDate(value, formatType);
      } else {
        result[key] = getOracleFormattedDate(validDate, formatType);
      }
    } else {
      result[key] = value;
    }
  });

  return result;
};

const InlineHtml: FC<SectionComponentTextInterface> = ({
  blocks: texts,
  extraData,
  bgColor,
}) => {
  const { horizontalPadding, verticalPadding } = extraData || {};
  const extraDataClasses = {
    [styles[`paddingHorizontal${capitalizeFirstLetter(horizontalPadding)}`]]: Boolean(horizontalPadding),
    [classes[`sharedWrapperPaddingVertical${capitalizeFirstLetter(verticalPadding)}`]]: Boolean(verticalPadding),
  };
  const wrapperStyles = cn(styles.wrapper, extraDataClasses);
  const replace = useHtmlParserReplace();
  const dynamicVariables = (texts?.find((item) => item?.__typename === 'CustomJson') || {}) as CustomJson;
  const formattedVariables = dynamicVariables?.data
    ? formatData(dynamicVariables?.data)
    : null;

  return (
    <section className={wrapperStyles} style={{ background: bgColor }}>
      {texts.map(({ fullText }) => {
        if (!fullText) {
          return null;
        }

        const updatedHtml = formattedVariables
          ? replaceContentfulVariables(fullText, formattedVariables)
          : fullText;

        return parse(updatedHtml, { replace });
      })}
    </section>
  );
};

export default withoutHydration()(InlineHtml);
